export default __webpack_public_path__ + "static/media/online-exam-platform-4.be727c36.jpg";